import React from 'react';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import LegacyFilterChips from './LegacyFilterChips';
import ChannelGroupChips from './ChannelGroupChips';
import FilterAndSortMenu from './FilterAndSortMenu';
import MobileFilterBar from './MobileFilter';
import { useFilter } from '../../FilterContext';

const DUMMY_GROUP_CHIPS = [1, 2, 3];

const FilterBar: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { hasGroups, loading } = useFilter();

    if (loading) {
        return (
            <Box
                data-testid="filter-bar-chip-skeleton"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap',
                }}
            >
                <Box
                    sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flex: 1 }}
                >
                    {DUMMY_GROUP_CHIPS.map((skeletonKey) => (
                        <Skeleton
                            key={skeletonKey}
                            data-testid="chip-skeleton"
                            variant="rounded"
                            sx={{ borderRadius: 16 }}
                            width={96}
                            height={32}
                        />
                    ))}
                </Box>
            </Box>
        );
    }

    if (hasGroups && isMobile) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap',
                }}
            >
                <MobileFilterBar />
                <Box sx={{ display: 'none' }}>
                    <ChannelGroupChips />
                    <FilterAndSortMenu />
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
                flexWrap: 'wrap',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flex: 1 }}>
                {hasGroups ? <ChannelGroupChips /> : <LegacyFilterChips />}
            </Box>
            {hasGroups && <FilterAndSortMenu />}
        </Box>
    );
};

export default FilterBar;
